import { Box, Button, Flex, HStack, Text, VStack } from '@chakra-ui/react'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Field, Formik } from 'formik'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { REPOSITORY } from '../../../api/repository/Repository'
import useFormButtons from '../../../components/FormButtons/hooks/useFormButtons'
import InputForm from '../../../components/InputForm/InputForm'
import SelectorField from '../../../components/Selector/SelectorField'
import UnderlineHeading from '../../../components/UnderlineText/UnderlineHeading'
import { useRequestStatusContext } from '../../../utils/hooks/Context/RequestStatusContext'
import { normalizeText } from '../../../utils/formats/validators'
import { useLabels } from '../../../utils/hooks/useLabels/useLabels'
import { colors } from '../../../utils/theme/styles'

export default function AccountRequest() {
  const { texts } = useLabels()
  const { onBack } = useFormButtons()
  const navigate = useNavigate()
  const { sSucursal, sCentroCosto, sEmpresa, lGrupo } =
    REPOSITORY.local.company.getCompanyData()
  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()

  const doneRefill = (code) => {
    if (code === 200) {
      navigate('/account/create-account')
      handleClose()
    }
    handleClose()
  }
  return (
    <Flex direction="column" w={'100%'}>
      <UnderlineHeading text={texts.complete_information} variant="h5" />
      <Formik
        initialValues={{
          sCentroCosto: null,
          sSucursal: null,
          // Grupo "Libre" por defecto con match tolerante (mismo criterio que
          // Individual.js / masivas): el label viene de sDescripcion y su casing
          // no es fiable, por lo que un === 'LIBRE' estricto fallaba.
          idGrupo: lGrupo.find((element) => normalizeText(element.label) === 'libre')
            ?.id,
          nCantCuentas: '',
        }}
        onSubmit={async (values) => {
          await REPOSITORY.wsEmpresa.accounts.noNominative
            .createNN({
              ...values,
              sEmpresa,
            })
            .then((response) => {
              handleSetTitle(response.data.sMensaje, response.status)
              handleChangeBody(
                <Button
                  variant="primary"
                  onClick={() => doneRefill(response.status)}
                >
                  {response.status === 200
                    ? 'Continuar'
                    : 'Contactar a soporte ahora'}
                </Button>,
              )
              handleOpen()
            })
            .catch((error) => {
              handleSetTitle(error.response.data.error, error.response.status)
              handleChangeBody(
                <Button
                  variant="primary"
                  onClick={() => doneRefill(error.response.status)}
                >
                  Contactar a soporte ahora
                </Button>,
              )
              handleOpen()
            })
        }}
        validate={(values) => {
          const errors = {}
          if (
            Number(values.nCantCuentas) > 100 ||
            Number(values.nCantCuentas) <= 0
          ) {
            errors.nCantCuentas = 'Debes ingresar un numero entre 0 y 100'
          }
          if (!values.sSucursal) {
            errors.sSucursal = 'Debes seleccionar una sucursal'
          }
          return errors
        }}
        validateOnMount
      >
        {({ values, handleChange, handleSubmit, errors, touched, isValid }) => (
          <VStack mt="16px" alignItems="flex-start" spacing="44px" mb="60px">
            <VStack spacing="16px" w="40%" ml="30px">
              <SelectorField
                isClearable
                placeholder="Seleccionar centro de costo"
                options={sCentroCosto || []}
                name="sCentroCosto"
                onChange={handleChange}
                value={values.sCentroCosto}
                title={texts.cost_center}
                titleType="overline"
              />

              <VStack w={'100%'} alignItems="flex-start">
                <Box w={'100%'}>
                  <SelectorField
                    isClearable
                    placeholder="Seleccionar sucursal"
                    options={sSucursal}
                    name="sSucursal"
                    onChange={handleChange}
                    value={values.sSucursal}
                    title={texts.branch_office}
                    titleType="overline"
                  />
                </Box>
                {errors.sSucursal && touched.sSucursal ? (
                  <Box>
                    <Text color={colors.log.error} variant="body3">
                      {errors.sSucursal}
                    </Text>
                  </Box>
                ) : null}
              </VStack>
              <SelectorField
                isClearable
                placeholder="Seleccionar grupo"
                options={lGrupo}
                name="idGrupo"
                value={values.idGrupo}
                onChange={handleChange}
                title={texts.group}
                titleType="overline"
              />
              <VStack w={'100%'} alignItems="flex-start">
                <Box w={'100%'}>
                  <Field
                    component={InputForm}
                    name="nCantCuentas"
                    id="nCantCuentas"
                    onChange={handleChange}
                    placeholder="0"
                    value={values.nCantCuentas}
                    title={'Número de BOLSILLOS (maximo 100 BOLSILLOS)'}
                  />
                </Box>
                {errors.nCantCuentas && touched.nCantCuentas ? (
                  <Box>
                    <Text color={colors.log.error} variant="body3">
                      {errors.nCantCuentas}
                    </Text>
                  </Box>
                ) : null}
              </VStack>
            </VStack>
            <HStack alignItems="center" spacing="23px">
              <Box>
                <FontAwesomeIcon icon={faExclamationTriangle} size="3x" />
              </Box>
              <Box>
                <Text variant="body1">
                  Por temas de seguridad, se pueden crear un máximo de 100
                  bolsillos por solicitud.
                </Text>
              </Box>
            </HStack>
            <HStack
              spacing="16px"
              alignSelf="center"
              w="40%"
              h="5vh"
              justifyContent="space-between"
            >
              <Button onClick={onBack} variant="white">
                {texts.cancel}
              </Button>
              <Button
                onClick={handleSubmit}
                variant={isValid ? 'primary' : 'gray'}
              >
                {texts.continue}
              </Button>
            </HStack>
          </VStack>
        )}
      </Formik>
    </Flex>
  )
}
